module.exports = __webpack_public_path__ + "img/icon3.2a92d735.png";